export type JobScheduleSummary = {
  isOrphan: boolean;
  message: string;
  count: number;
};

export function describeJobSchedules(job: { jobSchedules?: unknown[] }): JobScheduleSummary {
  const count = job?.jobSchedules?.length ?? 0;

  return {
    isOrphan: count === 0,
    message:
      count === 0
        ? "This job has no schedules. It is not visible on the calendar and is blocking new jobs for this contract."
        : `${count} scheduled ${count === 1 ? "occurrence" : "occurrences"}.`,
    count,
  };
}
